import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // ✅ this loads Tailwind + custom styles
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Optional: Measure performance (safe to ignore if you want)
reportWebVitals();
